'use client';
import React, { useState } from 'react';
import TopRow from './topRow';
import { useMainMenu } from '../../hooks/useMainMenu';
import DesktopMenu from './desktop/menu';
import MobileMenu from './mobile/menu';

const MainMenu = ({ mobileMenuOpen, toggleMobileMenu }) => {
  const configuration = useMainMenu();

  const content = JSON.parse(configuration.content);
  const logo = content.logo;
  const navigation = content.navigation;
  const secondary_navigation = content.top_navigation;

  const [visibleIndex, setVisibleIndex] = useState(null);

  const setVisible = (index) => {
    if (index === visibleIndex) {
      setVisibleIndex(null);
    } else {
      setVisibleIndex(index);
    }
  };

  const buttonStyle =
    'items-center ml-1 pl-5 pr-4 py-2 rounded-full border border-transparent hover:border-black/50 transition-border duration-300 ease-in-out text-base font-crystalCondensed whitespace-nowrap relative z-20';

  const menuParams = {
    logo,
    navigation,
    secondary_navigation,
    buttonStyle,
    visibleIndex,
    setVisible,
    mobileMenuOpen,
    toggleMobileMenu,
  };
  return (
    <>
      <TopRow />
      {/* Mobile menu */}
      <MobileMenu params={menuParams} />
      {/* Desktop menu */}
      <DesktopMenu params={menuParams} />
    </>
  );
};

export default MainMenu;
